
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import AdminPage from '../pages/admin/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
